import join from 'url-join';
import { asyncAction, http } from '../../util'; // createAction
import { handleError } from '../util';
import { chunk } from '../../util/lodash';
import { showToast } from '../../components/toast/actions';

const api2 = join(import.meta.env.VITE_API2_URL, 'v1');

export const updateDepartmentCatalogTypes = asyncAction({
  baseName: 'UPDATE_DEPARTMENT_CATALOG_TYPES',
  action:
    action =>
    ({ departmentId, catalogTypes }) =>
    dispatch => {
      dispatch(action.start());

      return http
        .post(join(api2, `/departments/${departmentId}/catalogTypes`), { catalogTypes })
        .then(() => action.success())
        .catch(error => handleError(dispatch, action, error));
    }
});

const batchUpdateDepartmentCatalogTypes = async departmentIdToCatalogTypes => {
  const departmentIds = Object.keys(departmentIdToCatalogTypes);
  const chunkedDepartments = chunk(departmentIds, 20);

  await Promise.all(
    chunkedDepartments.map(chunk => {
      const payload = {
        requests: chunk.map(deptId => ({
          id: deptId,
          url: `/v1/departments/${deptId}/catalogTypes`,
          method: 'POST',
          body: { catalogTypes: departmentIdToCatalogTypes[deptId].map(ct => ({ id: ct.id })) }
        }))
      };

      return http.post(`${api2}/$batch`, payload).catch(error => console.error(error));
    })
  );
};

export const bulkUpdateDepartmentCatalogTypes = asyncAction({
  baseName: 'BULK_UPDATE_DEPARTMENT_CATALOG_TYPES',
  action:
    action =>
    ({ departmentIdToCatalogTypes }) =>
    dispatch => {
      dispatch(action.start());

      return batchUpdateDepartmentCatalogTypes(departmentIdToCatalogTypes)
        .then(() => {
          action.success();
          dispatch(showToast({ message: 'Catalog Type Added to Department(s)', type: 'success' }));
        })
        .catch(error => handleError(dispatch, action, error));
    }
});

export const getAllAccounts = asyncAction({
  baseName: 'GET_ALL_ACCOUNTS',
  action: action => () => dispatch => {
    dispatch(action.start());

    return http
      .get(join(api2, '/accounts?fields=id,number,salesOrg,name&count=10000'))
      .then(({ data: response }) => dispatch(action.success(response.objects)))
      .catch(error => dispatch(action.error(error)));
  }
});

export const getAllCatalogTypes = asyncAction({
  baseName: 'GET_ALL_CATALOG_TYPES',
  action: action => () => dispatch => {
    dispatch(action.start());

    return http
      .get(join(api2, '/catalogTypes?count=10000'))
      .then(({ data: response }) => dispatch(action.success(response.objects)))
      .catch(error => handleError(dispatch, action, error));
  }
});
